export default __webpack_public_path__ + "static/media/prt_loading.680142d3.gif";